import { render } from "./GoogleSignInButton.vue?vue&type=template&id=271ef9d2"
import script from "./GoogleSignInButton.vue?vue&type=script&lang=js"
export * from "./GoogleSignInButton.vue?vue&type=script&lang=js"

import "./GoogleSignInButton.vue?vue&type=style&index=0&id=271ef9d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__